import React from 'react';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ children, requireStaff = false }) => {
  const token = localStorage.getItem('token'); // Verifica se o token está no localStorage
  const isStaff = localStorage.getItem('is_staff') === 'true'; // Verifica se o usuário é staff
  const isAuthenticated = !!token; // Verifica se o usuário está autenticado

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />; // Redireciona para login se não estiver autenticado
  }

  if (requireStaff && !isStaff) {
    return <Navigate to="/" replace />; // Redireciona para a página inicial se não for staff
  }

  return children;
};

export default ProtectedRoute;